import {Component} from '@angular/core';

@Component({
  selector: 'app-common-spacer',
  templateUrl: './common-spacer.component.html',
  styleUrl: './common-spacer.component.scss',
})
export class CommonSpacerComponent {
}
